import React from 'react'
import { useSelector } from 'react-redux'

import { Radio } from '@thanx/uikit/radio'
import { useStyletron } from '@thanx/uikit/theme'

import HandWave from 'components/Icons/HandWave'
import Sync from 'components/Icons/Sync'
import Section from 'components/Section'
import { buildTranslate } from 'locales'
import CmsPage from 'scenes/Cms/components/CmsPage'
import { selectCurrentMerchant } from 'selectors/merchant'
import { merchantTheme } from 'theme'

import IconText from './components/iconText'

const t = buildTranslate('cms.settings.instore_purchase_tracking')

const InstorePurchaseTracking: React.FC<{ showTitle?: boolean }> = ({
  showTitle = true,
}) => {
  const [css] = useStyletron()
  const merchant = useSelector(selectCurrentMerchant)
  const earnLoyaltyType = merchant.earn_loyalty_type

  const creditCardSelected = earnLoyaltyType === 'credit_card'
  const checkInSelected = earnLoyaltyType === 'check_in'

  const creditCardColor = creditCardSelected
    ? merchantTheme.colors.grey90
    : merchantTheme.colors.grey50
  const checkInColor = checkInSelected
    ? merchantTheme.colors.grey90
    : merchantTheme.colors.grey50

  return (
    <CmsPage
      showTitle={showTitle}
      title={t('title')}
      description={`${t(
        'description'
      )} <p><a href="https://help.thanx.com/hc/en-us/articles/30430757267095-Earning-mechanisms-at-Thanx" target="_blank" rel="noopener noreferrer" class="text-decoration-none">${t(
        'learn_more'
      )}</a></p>`}
    >
      <Section className="p-m mb-m">
        <div className="d-flex align-items-start">
          <Radio
            value="credit_card"
            checked={creditCardSelected}
            disabled={!creditCardSelected}
          />
          <div>
            <h4
              className={`fw-bold mb-xs ${css({
                color: creditCardColor,
              })}`}
            >
              {t('card_enrollment.title')}
            </h4>
            <IconText
              icon={<Sync pathColor={creditCardColor} />}
              text={t('card_enrollment.description')}
              textClassName={css({
                color: creditCardColor,
              })}
            />
            {!creditCardSelected && merchant.supports_credit_card_loyalty_type && (
              <a
                href="mailto:success@thanx.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                {t('contact_link')}
              </a>
            )}
          </div>
        </div>
      </Section>

      <Section className="p-m mb-m">
        <div className="d-flex align-items-start">
          <Radio
            value="check_in"
            checked={checkInSelected}
            disabled={!checkInSelected}
          />
          <div>
            <h4
              className={`fw-bold mb-xs ${css({
                color: checkInColor,
              })}`}
            >
              {t('manual_check_in.title')}
            </h4>
            <IconText
              icon={<HandWave pathColor={checkInColor} />}
              text={t('manual_check_in.description')}
              textClassName={css({
                color: checkInColor,
              })}
            />
            {!checkInSelected && (
              <a
                href="mailto:success@thanx.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                {t('contact_link')}
              </a>
            )}
          </div>
        </div>
      </Section>
    </CmsPage>
  )
}

export default InstorePurchaseTracking
